/**
 * IMPORTANT: 
 *   This module is used both on the server side and on the client side!
 * 
 *   It is FORBIDDEN to include configuration modules or variables here
 *   containing secret data that MUST NOT get to the CLIENT SIDE!
 */
const FIREBASE_API_KEY = process.env.FIREBASE_API_KEY || '';
const FIREBASE_PROJECT_ID = process.env.FIREBASE_PROJECT_ID || 'soundwise-a8e6f';
const FIREBASE_MESSAGING_SENDER_ID = process.env.FIREBASE_MESSAGING_SENDER_ID || '';

const firebaseConfig = {
  apiKey: FIREBASE_API_KEY,
  authDomain: `${FIREBASE_PROJECT_ID}.firebaseapp.com`,
  databaseURL: `https://${FIREBASE_PROJECT_ID}.firebaseio.com`,
  storageBucket: `${FIREBASE_PROJECT_ID}.appspot.com`,
  messagingSenderId: FIREBASE_MESSAGING_SENDER_ID,
};

const whiteLabelAppConfig = {
  // TODO move whiteLabelAppConfig values to process.env
  appName: 'Soundwise',
  appstoreUrl: 
    'https://itunes.apple.com/us/app/soundwise-learn-on-the-go/id1290299134?ls=1&mt=8',
  playstoreUrl:
    'https://play.google.com/store/apps/details?id=com.soundwisecms_mobile_android',
};

module.exports = {
  firebaseConfig,
  whiteLabelAppConfig,
};
